import { Link } from '@tanstack/react-router';
import { LuArrowRight } from 'react-icons/lu';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#e7e7e7] p-10">
      <div className="relative flex h-[728px] w-full max-w-[1136px] flex-col items-center overflow-hidden rounded-2xl bg-white">
        {/* Background blur effects */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div
            className="absolute top-[-193.38px] left-[591.79px] h-[630.18px] w-[796.91px] rounded-full bg-[#f6f3ff]"
            style={{ filter: 'blur(200px)' }}
          />
          <div
            className="absolute top-[395.79px] left-[-181.4px] h-[409.13px] w-[517.38px] rounded-full bg-[#edf8ff]"
            style={{ filter: 'blur(200px)' }}
          />
        </div>

        {/* Header with logo */}
        <header className="z-10 flex w-full pt-10 pl-10">
          <img src="/logo/agenthub.svg" alt="エージェントハブ" className="w-[317px]" />
        </header>

        {/* Main content */}
        <div className="z-10 mt-16 flex flex-col items-center">
          <div className="w-[458px]">
            <img src="/common/404.png" alt="404" className="w-full" />
            <p className="pt-4 text-center text-base font-bold">お探しのページは存在しません</p>
          </div>

          {/* Button */}
          <div className="mt-12 flex justify-center">
            <Link to="/agent">
              <button className="flex items-center justify-center gap-2 rounded-[5px] border-none bg-[#005fff] px-4 py-[14px] text-base leading-normal font-bold tracking-wider text-white no-underline hover:opacity-80">
                <span>ダッシュボードへ</span>
                <LuArrowRight className="size-3" aria-hidden />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
